<template>
  <div id="home">
    <Navbar current="Dashboard" />
    <Sidebar />
    <Container col="col-12">
      <Header
        :isSubHeader="false"
        title="Dashboard"
        :iconClass="'fa-solid fa-chart-simple text-primary'"
      />

      <!-- Abas -->
      <ul class="nav nav-tabs mb-4">
        <li v-for="tab in tabs" :key="tab.id" class="nav-item">
          <a
            class="nav-link cursor-pointer"
            :class="{ active: activeTab === tab.id }"
            @click.prevent="selectTab(tab.id)"
          >
            <i :class="tab.icon" class="me-1"></i>
            {{ tab.label }}
          </a>
        </li>
      </ul>

      <div
        v-for="tab in tabs"
        v-show="activeTab === tab.id"
        :key="'pane-' + tab.id"
      >
        <!-- Loading -->
        <div v-if="loading[tab.id]" class="text-center py-6 text-muted">
          <div class="spinner-border text-primary mb-3" role="status"></div>
          <p class="mb-0">Carregando {{ tab.label }}...</p>
        </div>

        <!-- Erro -->
        <div v-else-if="errored[tab.id]" class="text-center py-6 text-muted">
          <i class="fa-solid fa-triangle-exclamation fa-2x mb-3"></i>
          <p class="mb-2">Não foi possível carregar os dados.</p>
          <button class="btn btn-sm btn-outline-primary" @click="retryTab(tab.id)">
            Tentar novamente
          </button>
        </div>

        <!-- Conteúdo -->
        <template v-else-if="data[tab.id]">
          <DashBigNumbers v-if="tab.id === 'big'" :data="data.big" />
          <DashUsers v-else-if="tab.id === 'users'" :data="data.users" />
          <DashAppointments
            v-else-if="tab.id === 'appointments'"
            :data="data.appointments"
          />
          <DashKpis v-else-if="tab.id === 'kpis'" :data="data.kpis" />
          <DashFinancial
            v-else-if="tab.id === 'financial'"
            :data="data.financial"
          />
        </template>
      </div>
    </Container>
  </div>
</template>

<script>
import HomeController from "./HomeController";
export default HomeController;
</script>

<style scoped>
.py-6 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
</style>
